import { useCallback, useEffect, useRef, useState } from 'react';

const SCRIPT_ID = 'react-gpt-ads-umd';

export const useReactGptLoader = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const timeoutRef = useRef();

    const checkReactGPTAds = () => {
        if (window.ReactGPTAds) {
            setIsLoaded(true);
        } else {
            timeoutRef.current = setTimeout(checkReactGPTAds, 500);
        }
    };

    const loadScript = useCallback((src) => {
        new Promise((resolve) => {
            if (!isLoaded && !document.getElementById(SCRIPT_ID)) {
                const script = document.createElement('script');
                script.defer = true;
                script.src = src;
                script.id = SCRIPT_ID;
                script.onload = () => {
                    resolve();
                };
                document.body.appendChild(script);
            } else {
                resolve();
            }
        }).then(() => {
            checkReactGPTAds();
        });
    }, []);

    useEffect(() => {
        if (window.REACT_GPT_ADS_URL && !isLoaded) {
            loadScript(window.REACT_GPT_ADS_URL);
        }

        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);

    return isLoaded;
};
